import { Component, OnInit, inject } from '@angular/core';
import { ICommunityService } from '@tokens/injection.tokens';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  private module = inject(ICommunityService);
  private route = inject(Router);
  headLess = false;

  ngOnInit(): void {
    document.body.setAttribute('data-layout', 'horizontal');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-sidebar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-sidebar-small');

    // Set Headless
    const segments = this.route.url.split('/');
    this.headLess = segments.indexOf('headless') != -1;
  }
}
